import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Layouts
import MainLayout from './components/Layout/MainLayout';
import AuthLayout from './components/Layout/AuthLayout';

// Pages
import Login from './pages/Auth/Login';
import ResetPassword from './pages/Auth/ResetPassword';
import Dashboard from './pages/Dashboard/Dashboard';
import Tasks from './pages/Tasks/Tasks';
import AssistantManagerTasks from './pages/Tasks/AssistantManagerTasks';
import DailyDairyOrderRecording from './pages/Tasks/DailyDairyOrderRecording';
import GoodsReceived from './pages/Tasks/GoodsReceived';
import ItemChangeLog from './pages/Tasks/ItemChangeLog';
import ProductReturnsTask from './pages/Tasks/ProductReturnsTask';
import ProduceInventoryTracker from './pages/Tasks/ProduceInventoryTracker';
import FullInventoryCount from './pages/Tasks/FullInventoryCount';
import DailyLiquorCount from './pages/Tasks/DailyLiquorCount';
import TaskDetail from './pages/Tasks/TaskDetail';
import InventoryDetail from './pages/Inventory/InventoryDetail';
import Notifications from './pages/Notifications/Notifications';
import Profile from './pages/Profile/Profile';
import ReportsHub from './pages/Reports/ReportsHub';
import BiHub from './pages/BI/BiHub';
import UserManagement from './pages/Admin/UserManagement';
import FeatureAccessManagement from './pages/Admin/FeatureAccessManagement';
import ProductSyncControl from './pages/Admin/ProductSyncControl';
import CategoryClassificationManagement from './pages/Admin/CategoryClassificationManagement';
import AssetManagement from './pages/Admin/AssetManagement';
import WorkforceRoster from './pages/Workforce/WorkforceRoster';
import NotFound from './pages/NotFound';

// Components
import ProtectedRoute from './components/Auth/ProtectedRoute';

function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Task Routes */}
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/logistics-desk" element={<AssistantManagerTasks />} />
        <Route path="/task2" element={<ReportsHub />} />
        <Route path="/dairy-order-recording" element={<DailyDairyOrderRecording />} />
        <Route path="/goods-received" element={<GoodsReceived />} />
        <Route path="/item-change-log" element={<ItemChangeLog />} />
        <Route path="/product-returns" element={<ProductReturnsTask />} />
        <Route path="/produce-inventory-tracker" element={<ProduceInventoryTracker />} />
        <Route path="/full-inventory-count" element={<FullInventoryCount />} />
        <Route path="/daily-liquor-count" element={<DailyLiquorCount />} />
        <Route path="/task-report" element={<ReportsHub />} />
        <Route path="/reports" element={<ReportsHub />} />
        <Route path="/bi" element={<BiHub />} />
        <Route path="/bi/overview" element={<BiHub />} />
        <Route path="/bi/funnel" element={<BiHub />} />
        <Route path="/bi/promo" element={<BiHub />} />
        <Route path="/bi/calendar" element={<BiHub />} />
        <Route path="/bi/ba-report" element={<BiHub />} />
        <Route path="/dairy-order-report" element={<ReportsHub />} />
        <Route path="/goods-received-report" element={<ReportsHub />} />
        <Route path="/product-returns-report" element={<ReportsHub />} />
        <Route path="/produce-inventory-tracker-report" element={<ReportsHub />} />
        <Route path="/full-inventory-report" element={<ReportsHub />} />
        <Route path="/daily-liquor-count-report" element={<ReportsHub />} />
        <Route path="/final-report" element={<Navigate to="/dashboard" replace />} />
        <Route path="/workforce-roster" element={<WorkforceRoster />} />
        <Route path="/tasks/:id" element={<TaskDetail />} />
        
        {/* Inventory Routes */}
        <Route path="/inventory" element={<ReportsHub />} />
        <Route path="/inventory/:id" element={<InventoryDetail />} />
        
        {/* Notice Board */}
        <Route path="/notifications" element={<Notifications />} />

        {/* Account */}
        <Route path="/profile" element={<Profile />} />
        
        {/* Admin */}
        <Route path="/admin/users" element={<UserManagement />} />
        <Route path="/admin/feature-access" element={<FeatureAccessManagement />} />
        <Route path="/admin/category-classifications" element={<CategoryClassificationManagement />} />
        <Route path="/admin/assets" element={<AssetManagement />} />
        <Route path="/admin/product-sync" element={<ProductSyncControl />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
